import React from 'react';
import store, { noticeActions } from '@apply/adminStore';
import { NoticeStatusTypeOptions } from '@apply/constants';
import { formatDate } from '@apply/ui';

export const ViewNoticeButton = ({ notice }) => {
    const { dispatch } = store;

    const viewNotice = (event, id) => {
        event.preventDefault();
        event.stopPropagation();

        dispatch(
            noticeActions.setViewNoticeModal({
                viewNoticeModal: { isOpen: true, noticeId: id },
            })
        );
    };

    const status = NoticeStatusTypeOptions.find((s) => s.id === notice.statusId);

    return (
        <button
            className='link'
            id='viewNotice'
            onClick={(e) => {
                viewNotice(e, notice.id);
            }}
            style={{ color: status.color }}
            title={`Click to view  Notice details (${status.name})`}
        >
            {formatDate(new Date(notice.noticeDate))}
        </button>
    );
};
